// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__5NqiM","panel":"styles_panel__mG5W9","image":"styles_image__8jLqV","baseStyles":"styles_baseStyles__8yy7D","readerOnly":"styles_readerOnly__Kd7aN"};